import React from "react";
import StudentTestimonialFormPage from "../components/student-testimonials/StudentTestimonialFormPage";

const StudentTestimonialEdit = () => <StudentTestimonialFormPage mode="edit" />;

export default StudentTestimonialEdit;
